import * as axiosBase from '@/api/index.js';

// 查询活动
export let queryAll = function(params) {
  return axiosBase.GET("/medicalapp/activity/queryAll", params)
}

//查询我的活动
export let querySelf = function(params) {
  return axiosBase.GET("/medicalapp/activity/querySelf", params)
}

// 创建活动
export let create = function(params) {
  return axiosBase.POST("/medicalapp/activity/create", params)
}



// WEBPACK FOOTER //
// ./src/api/activity.js